export enum DurationUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
}

const DURATION_SECOND_CONVERSIONS = {
  [DurationUnit.SECONDS]: 1,
  [DurationUnit.MINUTES]: 60,
  [DurationUnit.HOURS]: 3600,
  [DurationUnit.DAYS]: 24 * 3600, // NOTE: this assumes 24 hours in a day!
};

export function convertFromDurationToSeconds(
  value: number,
  unit: DurationUnit,
) {
  const multiplier = DURATION_SECOND_CONVERSIONS[unit];
  if (typeof multiplier !== 'number') {
    throw new Error(
      `Could not find multiplier to convert from ${unit} to seconds.`,
    );
  }
  return multiplier * value;
}
